<template>
  <p
    v-html="block.data.text"
    class="width-100-pr"
  >
  </p>
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockParagraph',

  props: {
    block: Object
  }
}
</script>
